import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Drawer,
  Typography,
  IconButton,
  InputAdornment,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  TextField,
  Badge,
  Skeleton,
  Paper,
} from '@mui/material';
import { Icon } from '@iconify/react/dist/iconify.js';
import ChatBox from './ChatBox';
import ChatListItem from './ChatListItem';
import { useSocket } from '../../socket/SocketContext';
import AddMenuFab from './AddMenuFab';
import ChatCreation from './ChatCreation';
import GroupCreation from './GroupCreation';
import chatApi from './ChatApi';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { closeChat, openChat, setRefreashNeeded } from '../../redux/features/chatSlice';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Snackbar, Alert } from '@mui/material';
import { addTotalChatCount } from '../../redux/features/socketNotificationSlice';
export default function ChatDrawer() {
  const dispatch = useDispatch();
  const socket = useSocket();
  const chat = useSelector((state) => state.chat);
  const { totalChatCount } = useSelector((state) => state.socketNotification);
  const { open, chatRoomId, groupCreationUsersList, groupName, rowDetails } = chat;
  const drawerOpen = open;

  const [activeTab, setActiveTab] = useState(0); // 0: All, 1: Personal, 2: Groups
  const [searchTerm, setSearchTerm] = useState('');
  const [messages, setMessages] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [chats, setChats] = useState([]); //ALL CHATS OF USER
  const [activeChatRoomId, setActiveChatRoomId] = useState(null); //ACTIVE CHAT ROOM ID BY CLICK WHICH CHAT ENTER
  const [contentBox, SetContentBox] = useState(null);
  const [listLoading, setListLoading] = useState(true);
  const [messagesLoading, setMessagesLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [groupCreating, setGroupCreating] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const showAlert = (message, severity = 'success') => {
    setAlert({ open: true, message, severity });
  };

  const typingTimeoutRef = useRef(null);
  const activeChatRef = useRef(null);

  const loginedUserId = React.useMemo(() => {
    try {
      const cred = localStorage.getItem('cred');
      return cred ? JSON.parse(cred)?.profile?.userId : null;
    } catch {
      return null;
    }
  }, []);

  //when activechatroom id set we need to get the object of that chat means active chat
  const activeChat = React.useMemo(() => {
    if (!activeChatRoomId) return null;
    return chats.find((c) => c.chat_room_id == activeChatRoomId) || null;
  }, [activeChatRoomId, chats]);

  useEffect(() => {
    activeChatRef.current = activeChat;
  }, [activeChat]);

  useEffect(() => {
    if(drawerOpen){
      dispatch(addTotalChatCount(chats.reduce((acc, data) => acc + data.unread_count, 0)))
    }
  }, [chats,drawerOpen]);

  // useEffect(() => {
  //   if (!drawerOpen) return;
  //   if (chatRoomId) {
  //     console.log('chatRoomId exist so direct selectChat', chatRoomId);
  //     selectChat(chatRoomId); //its a functin make it as activeChatID and then also activeChat with room id and also getting message
  //   } else if (groupCreationUsersList.length > 0) {
  //     console.log('groupCreationUsersList exist so direct createNewGroup', groupCreationUsersList);
  //     createNewGroup(groupName || generateGroupName(), groupCreationUsersList);
  //   }
  // }, [open, chatRoomId, groupCreationUsersList]);

  /* -------------------- 🔑 SINGLE INITIALIZER -------------------- */
  useEffect(() => {
    if (!drawerOpen) return;

    const init = async () => {
      const chatList = await getChatList();

      // CASE 1: Redux chatRoomId → open specific chat
      if (chatRoomId) {
        const exists = chatList.some((c) => c.chat_room_id === chatRoomId);

        if (!exists) {
          // console.log('You are not part of this chat. Please ask the admin to add you.');
          // enqueueSnackbar('You are not part of this chat. Please ask the admin to add you.', {
          //   variant: 'warning',
          //   anchorOrigin: {
          //     vertical: 'bottom',
          //     horizontal: 'right',
          //   },
          //   style: {
          //     fontSize: '0.75rem',
          //     padding: '6px 10px',
          //     minWidth: 'auto',
          //     borderRadius: '6px',
          //   },
          // });
          showAlert('Access denied. Contact Group admin.', 'warning');

          return;
        }

        await selectChat(chatRoomId);
        return;
      }

      // CASE 2: Group creation
      if (!chatRoomId && groupCreationUsersList.length > 0) {
        await createNewGroup(groupName || generateGroupName(), groupCreationUsersList);
      }
    };

    init();
  }, [drawerOpen, chatRoomId, groupCreationUsersList]);

  const handleClose = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    setChats([]);
    setActiveChatRoomId(null);
    SetContentBox(null);
    setMessages([]);
    dispatch(closeChat());
  };

  // useEffect(() => {
  //   if (open) {
  //     console.log('CHAT STATE →', {
  //       reduxChatRoomId: chatRoomId,
  //       reduxGroupCreationUsersList: groupCreationUsersList,
  //       reduxGroupName: groupName,
  //       reduxRowDetails: rowDetails,
  //       activeChatRoomId,
  //       activeChat,
  //       chats,
  //       messages,
  //       drawerOpen,
  //     });
  //   }
  // }, [activeChatRoomId, activeChat, chats, messages, drawerOpen]);

  const generateGroupName = () => {
    const now = new Date();
    const date = now.toLocaleDateString('en-GB'); // 12/01/2026
    const time = now.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
    }); // 14:32

    return `Group ${date} ${time}`;
  };

   const getChatList = async () => {
    try {
      setListLoading(true);
      const data = await chatApi.getChatListApiTrigger();
      setChats(data); 
      return data;
    } catch (err) {
      console.error('Failed to load chat list', err);
      setChats([]);
    } finally {
      setListLoading(false);
    }
  };

  const selectChat = async (chatRoomId) => {
    try {
      setMessagesLoading(true);
      setMessages([]); // reset FIRST

      const res = await chatApi.getMessages(chatRoomId, { page: 1, limit: 10, search: '' });
      const normalizedMessages = Array.isArray(res) ? [...res].reverse() : [];

      setActiveChatRoomId(chatRoomId);
      setPage(1);
      setHasMore(true);
      setMessages(normalizedMessages);
      if (res.length === 0) {
        setHasMore(false);
      }
      if (socket) {
        socket.emit('mark_read', { chat_room_id: chatRoomId });
      }
      setChats((prev) => prev.map((c) => (c.chat_room_id === chatRoomId ? { ...c, unread_count: 0 } : c)));
    } catch (error) {
      console.error('❌ Error loading messages:', error);
    } finally {
      setMessagesLoading(false);
    }
  };

  const loadMoreMessages = async () => {
    if (!hasMore || loadingMore || !activeChatRoomId) return;

    try {
      setLoadingMore(true);
      const nextPage = page + 1;

      const res = await chatApi.getMessages(activeChatRoomId, {
        page: nextPage,
      });

      if (res.length === 0) {
        setHasMore(false);
        return;
      }
      const normalizedMessages = [...res].reverse();
      setMessages((prev) => [...normalizedMessages, ...prev]);
      setPage(nextPage);
    } finally {
      setLoadingMore(false);
    }
  };

  const handleTyping = () => {
    if (!socket || !activeChat) return;

    const isGroup = activeChat.type === 'GROUP';
    const otherUserId = isGroup ? undefined : activeChat.participants[0].userId;

    socket.emit('user_typing', {
      chat_room_id: activeChat.chat_room_id,
      toUserId: otherUserId,
    });

    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    typingTimeoutRef.current = setTimeout(() => {
      socket.emit('user_stopped_typing', {
        chat_room_id: activeChat.chat_room_id,
        toUserId: otherUserId,
      });
    }, 2000);
  };

  const sendMessage = (text) => {
    if (!socket || !activeChat || !text.trim()) return;
    // console.log('text', text);
    const isGroup = activeChat.type === 'GROUP';
    const otherUserId = isGroup ? undefined : activeChat.participants[0].userId;

    socket.emit('send_message', {
      chat_room_id: activeChat.chat_room_id,
      toUserId: otherUserId,
      message: text.trim(),
    });

    socket.emit('user_stopped_typing', {
      chat_room_id: activeChat.chat_room_id,
      toUserId: otherUserId,
    });
  };

  const createNewGroup = async (groupName, memberIds) => {
    try {
      // console.log('creating new group with ', groupName, memberIds);

      setGroupCreating(true);
      setMessagesLoading(true);
      setListLoading(true);
      const res = await chatApi.createGroup(groupName, memberIds, rowDetails);
      const room = res.data;
      if (!room?.chat_room_id) return;
      const updatedChats = await getChatList();
      const exists = updatedChats.find((c) => c.chat_room_id === room.chat_room_id);
      if (exists) {
        await selectChat(room.chat_room_id);
      }
      dispatch(setRefreashNeeded(true));
    } catch (error) {
      console.error('❌ Error creating group:', error);
      // alert('Failed to create group');
    } finally {
      setGroupCreating(false);
      setMessagesLoading(false);
      setListLoading(false);
    }
  };

  useEffect(() => {
    if (!socket) return;
    // if (drawerOpen) {
    //   getChatList();
    // }

    // socket.on('new_message', (msg) => {
    //   const active = activeChatRef.current;
    //   if (msg.chat_room_id === active?.chat_room_id) {
    //     setMessages((prev) => {
    //       const exists = prev.find((m) => m.message_id === msg.message_id);
    //       if (exists) return prev;
    //       return [...prev, msg];
    //     });

    //     if (msg.sender !== loginedUserId) {
    //       socket.emit('mark_read', { chat_room_id: msg.chat_room_id });
    //     }
    //   }

    // });

    socket.on('new_message', (msg) => {
      // console.log('new message', msg);

      const active = activeChatRef.current;

      // CASE 1: Active chat → update messages
      if (msg.chat_room_id === active?.chat_room_id) {
        setMessages((prev) => {
          const exists = prev.find((m) => m.message_id === msg.message_id);
          if (exists) return prev;
          return [...prev, msg];
        });

        if (msg.sender !== loginedUserId) {
          socket.emit('mark_read', { chat_room_id: msg.chat_room_id });
        }
      }
      // CASE 2: Other chat → update chat list
      else {
        setChats((prev) => {
          const index = prev.findIndex((c) => c.chat_room_id === msg.chat_room_id);

          // Existing chat → update it
          if (index !== -1) {
            const updated = [...prev];
            updated[index] = {
              ...updated[index],
              last_message: msg.message,
              last_message_time: msg.createdAt,
              unread_count: (updated[index].unread_count || 0) + 1,
            };

            // Move chat to top
            const [chat] = updated.splice(index, 1);
            return [chat, ...updated];
          }

          // Brand-new chat → add to top
          return [
            {
              chat_room_id: msg.chat_room_id,
              last_message: msg.message,
              last_message_time: msg.createdAt,
              unread_count: 1,
              type: msg.type,
              group_name: msg.group_name,
              participants: msg.participants,
            },
            ...prev,
          ];
        });
      }
    });

    socket.on('chat_list_update', (update) => {
      const active = activeChatRef.current;
      // console.log('📋 Chat list update:', update);
      setChats((prev) => {
        const index = prev.findIndex((c) => c.chat_room_id === update.chat_room_id);

        if (index !== -1) {
          const updated = [...prev];
          updated[index] = {
            ...updated[index],
            last_message: update.last_message,
            last_message_time: update.last_message_time,
            last_message_sender: update.last_message_sender,
            unread_count:
              active?.chat_room_id === update.chat_room_id
                ? 0
                : (update.unread_count ?? updated[index].unread_count + 1),
          };

          const [movedChat] = updated.splice(index, 1);
          return [movedChat, ...updated];
        } else {
          //CANNOT FIND IN CURRENT CHAT LIST SO ADD NEW CHAT
          return [
            {
              chat_room_id: update.chat_room_id,
              type: update.type,
              group_name: update.group_name,
              group_photo: update.group_photo,
              other_user_id: update.other_user_id,
              other_user_name: update.other_user_name,
              other_user_photo: update.other_user_photo,
              last_message: update.last_message,
              last_message_time: update.last_message_time,
              last_message_sender: update.last_message_sender,
              member_count: update.member_count,
              unread_count: update.unread_count ?? 1,
            },
            ...prev,
          ];
        }
      });
    });

    socket.on('messages_read', ({ chat_room_id }) => {
      const active = activeChatRef.current;
      if (active?.chat_room_id === chat_room_id) {
        setChats((prev) => prev.map((c) => (c.chat_room_id === chat_room_id ? { ...c, unread_count: 0 } : c)));
      }
    });

    socket.on('user_typing', ({ chat_room_id, typing, user_id }) => {
      const active = activeChatRef.current;
      if (active?.chat_room_id === chat_room_id) {
        if (user_id != loginedUserId) {
          setIsTyping(typing);
        }
      }
    });

    socket.on('group_members_added', ({ chat_room_id }) => {
      const active = activeChatRef.current;
      if (active && active?.chat_room_id === chat_room_id) {
        getChatList();
      }
    });

    socket.on('group_member_left', ({ chat_room_id }) => {
      const active = activeChatRef.current;
      if (active && active?.chat_room_id === chat_room_id) {
        getChatList();
      }
    });

    socket.on('error', (error) => {
      console.error('❌ Socket error:', error);
      showAlert(error.message, 'error');
    });

    return () => {
      socket.off('new_message');
      socket.off('chat_list_update');
      socket.off('messages_read');
      socket.off('user_typing');
      socket.off('group_members_added');
      socket.off('group_member_left');
    };
  }, [socket, drawerOpen, loginedUserId]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleBackToList = () => {
    setActiveChatRoomId(null);
    SetContentBox(null);
  };

  const displayedList = chats
    .filter((chat) => {
      if (activeTab === 1) return chat.type === 'ONE_TO_ONE';
      if (activeTab === 2) return chat.type === 'GROUP';
      return true;
    })
    .filter((chat) => {
      const search = searchTerm.toLowerCase();

      const name = chat.type === 'GROUP' ? chat.group_name : chat.participants?.[0]?.name;

      return name?.toLowerCase().includes(search);
    })
    .map((chat) => <ChatListItem key={chat.chat_room_id} chat={chat} onClick={selectChat} />);

  return (
    <>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') return;
          handleClose();
        }}
        disableRestoreFocus
        PaperProps={{
          sx: {
            width: { xs: '100%', sm: 420 },
            m: { xs: 0, sm: 2 },
            height: {
              xs: '100%', // 👈 full height on mobile
              sm: 'calc(100% - 32px)', // 👈 margin-adjusted height on sm+
            },
            borderRadius: { xs: 0, sm: 2 },
            overflow: 'hidden',
            backgroundColor: '#551364',
          },
        }}
      >
        {groupCreating && drawerOpen && !activeChat && !chatRoomId ? (
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
              backgroundColor: '#f9ecff',
            }}
          >
            <Skeleton variant="circular" width={64} height={64} />
            <Typography fontWeight={700} fontSize="1rem">
              Creating group…
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Please wait a moment
            </Typography>
          </Box>
        ) : activeChat ? (
          <ChatBox
            messages={messages}
            chat={activeChat}
            onBack={handleBackToList}
            onClose={handleClose}
            loginedUserId={loginedUserId}
            onSend={sendMessage}
            onTyping={handleTyping}
            isTyping={isTyping}
            messagesLoading={messagesLoading}
            selectChat={selectChat}
            loadMoreMessages={loadMoreMessages}
            hasMore={hasMore}
            loadingMore={loadingMore}
            getChatList={getChatList}
            handleBackToList={handleBackToList}
          />
        ) : (
          <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box
              sx={{
                px: 2,
                py: 2,
                bgcolor: 'background.paper',
                borderBottom: '1px solid',
                borderColor: 'divider',
                backgroundColor: '#551364',
                backgroundImage: `url("/static/illustrations/chatTop.png")`,
              }}
            >
              {/* Top row */}
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box display="flex" alignItems="center" gap={1.2}>
                  {/* Logo */}
                  <Box
                    component="img"
                    // src="/static/illustrations/Genie.png"
                    src="https://student.intervaledu.com/_next/image?url=https%3A%2F%2Fportal.teaminterval.net%2Fstatic%2Fmedia%2Fmap.7dd1ec7c87cddefd09e4.gif&w=128&q=75"
                    alt="Genie"
                    sx={{ height: 30, width: 30, transform: 'scale(1.25)' }}
                  />

                  {/* App Name */}
                  <Box>
                    <Typography
                      sx={{
                        fontSize: 16,
                        fontWeight: 700,
                        lineHeight: 1.1,
                        letterSpacing: 0.3,
                        display: 'flex',
                        alignItems: 'baseline', // 👈 key fix
                      }}
                    >
                      {/* Big I */}
                      <Typography
                        component="span"
                        sx={{
                          fontSize: 20,
                          fontWeight: 700,
                          lineHeight: 1,
                          color: 'white',
                          letterSpacing: 0.3,
                        }}
                      >
                        i
                      </Typography>

                      {/* n */}
                      <Typography component="span" sx={{ color: 'white', fontWeight: 600, letterSpacing: 0.3 }}>
                        n
                      </Typography>

                      {/* te */}
                      <Typography component="span" sx={{ color: 'white', fontWeight: 600, letterSpacing: 0.3 }}>
                        te
                      </Typography>

                      {/* Chat */}
                      <Typography component="span" sx={{ color: 'white', ml: 0.5, fontWeight: 600 }}>
                        Chat
                      </Typography>
                    </Typography>
                    {/* <Typography
                        sx={{
                          fontSize: 11,
                          color: 'rgba(255,255,255,0.75)',
                        }}
                      >
                        Team Conversations
                      </Typography> */}
                  </Box>
                </Box>

                <IconButton size="small" onClick={handleClose} sx={{ color: '#ffffff' }}>
                  <HighlightOffIcon sx={{ color: '#fff', fontSize: 20 }} />
                </IconButton>
              </Box>

              {/* Secondary content */}
              {contentBox === null && (
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Search people or groups"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Icon icon="mdi:magnify" />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    mt: 1,
                    bgcolor: 'grey.100',
                    borderRadius: 2,
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                  }}
                />
              )}
            </Box>

            {/* Tabs */}
            {contentBox == 'createChat' ? (
              <ChatCreation selectChat={selectChat} getChatList={getChatList} setListLoading={setListLoading} />
            ) : contentBox == 'creatGroup' ? (
              <GroupCreation selectChat={selectChat} setListLoading={setListLoading} getChatList={getChatList} />
            ) : (
              <Box
                sx={{
                  flexGrow: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  minHeight: 0,
                }}
              >
                {/* TAB SECTION START */}
                <Box px={1.5} py={1.5} sx={{ bgcolor: '#f9ecff', borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
                  <Box
                    sx={{
                      bgcolor: '#ffffff',
                      // p: 1.5,
                      borderRadius: '999px',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                    }}
                  >
                    <Tabs
                      value={activeTab}
                      onChange={handleTabChange}
                      variant="fullWidth"
                      TabIndicatorProps={{ style: { display: 'none' } }}
                      sx={{
                        minHeight: 'unset',
                        '& .MuiTabs-flexContainer': {
                          gap: 1,
                          p: 1.5,
                        },
                      }}
                    >
                      {['All', 'Personal', 'Groups'].map((label) => (
                        <Tab
                          key={label}
                          label={label}
                          sx={{
                            border: '1px solid #620a9954',
                            minHeight: 'unset',
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: '0.9rem',
                            borderRadius: '999px',
                            px: 3,
                            py: 1.2,

                            bgcolor: 'rgba(86, 31, 110, 0.08)',
                            color: '#561f6e',

                            transition: 'all 0.25s ease',

                            '&:hover': {
                              bgcolor: 'rgba(86, 31, 110, 0.14)',
                            },

                            '&.Mui-selected': {
                              bgcolor: '  #561f6e',
                              color: '#ffffff',
                              transform: 'scale(1.06)',
                            },
                          }}
                        />
                      ))}
                    </Tabs>
                  </Box>
                </Box>

                {/* TAB SECTION END  */}

                {/* List Content */}
                <List
                  sx={{
                    flexGrow: 1,
                    overflowY: 'auto',
                    px: 1,
                    py: 1,
                    backgroundColor: '#f9ecff',
                  }}
                >
                  {listLoading ? (
                    [1, 2, 3, 4, 5, 6].map((i) => (
                      <Paper key={i} sx={{ mb: 1 }}>
                        <ListItem key={i}>
                          <ListItemAvatar>
                            <Skeleton variant="circular" width={40} height={40} />
                          </ListItemAvatar>
                          <ListItemText
                            primaryTypographyProps={{ component: 'div' }}
                            primary={<Skeleton width="100%" height={60} />}
                          />
                        </ListItem>
                      </Paper>
                    ))
                  ) : displayedList.length > 0 ? (
                    displayedList
                  ) : (
                    <Box
                      sx={{
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        px: 3,
                        py: 6,
                        gap: 1.5,
                      }}
                    >
                      <Box
                        sx={{
                          width: 80,
                          height: 80,
                          borderRadius: '50%',
                          bgcolor: 'rgba(86,31,110,0.08)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          mb: 1,
                        }}
                      >
                        <Icon icon="mdi:chat-outline" width={38} height={38} color="#561f6e" />
                      </Box>

                      {/* Title */}
                      <Typography fontWeight={700} fontSize="1rem" color="#0c3e6b">
                        No conversations yet
                      </Typography>

                      {/* Subtitle */}
                      <Typography
                        variant="body2"
                        sx={{
                          color: 'text.secondary',
                          maxWidth: 220,
                        }}
                      >
                        Start a chat or create a group to begin the conversation.
                      </Typography>
                    </Box>
                  )}
                </List>
              </Box>
            )}
          </Box>
        )}

        {activeChat === null && (
          <AddMenuFab SetContentBox={SetContentBox} contentBox={contentBox} hasChats={chats.length > 0} />
        )}
      </Drawer>

      {/* {!drawerOpen && (
        <IconButton
          onClick={() => dispatch(openChat({}))}
          sx={{
            position: 'fixed',
            bottom: { xs: 12, sm: 24 },
            right: { xs: 12, sm: 24 },
            zIndex: 1199,
            width: { xs: 46, sm: 58 },
            height: { xs: 46, sm: 58 },
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #561f6e, #0c3e6b)',
            color: '#fff',
            boxShadow: {
              xs: '0 6px 18px rgba(12,62,107,0.35)',
              sm: '0 10px 30px rgba(12,62,107,0.45)',
            },
            animation: { xs: 'none', sm: 'pulseGlow 2.5s infinite' },
            '&:hover': {
              transform: { sm: 'scale(1.08)' },
              boxShadow: { sm: '0 14px 40px rgba(12,62,107,0.6)' },
            },
            transition: 'all 0.3s ease',
            '@keyframes pulseGlow': {
              '0%': {
                boxShadow: '0 0 0 0 rgba(86,31,110,0.55)',
              },
              '70%': {
                boxShadow: '0 0 0 16px rgba(86,31,110,0)',
              },
              '100%': {
                boxShadow: '0 0 0 0 rgba(86,31,110,0)',
              },
            },
          }}
        >
          <Icon
            icon="mdi:chat"
            width={26}
            height={26}
            style={{
              animation: 'iconBounce 2.5s infinite',
            }}
          />

          <style>
            {`
          @keyframes iconBounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-3px); }
          }
        `}
          </style>
        </IconButton>
      )} */}

      {!drawerOpen && (
        <Badge
          badgeContent={totalChatCount}
          color="error"
          max={99}
          invisible={!totalChatCount}
          sx={{
            position: 'fixed',
            bottom: { xs: 12, sm: 24 },
            right: { xs: 12, sm: 24 },
            zIndex: 1200,
            '& .MuiBadge-badge': {
              fontSize: '0.7rem',
              fontWeight: 700,
              minWidth: 18,
              height: 18,
              borderRadius: '50%',
            },
          }}
        >
          <IconButton
            onClick={() => dispatch(openChat({}))}
            sx={{
              width: { xs: 46, sm: 58 },
              height: { xs: 46, sm: 58 },
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #561f6e, #0c3e6b)',
              color: '#fff',
              boxShadow: {
                xs: '0 6px 18px rgba(12,62,107,0.35)',
                sm: '0 10px 30px rgba(12,62,107,0.45)',
              },
              '&:hover': {
                transform: { sm: 'scale(1.08)' },
                boxShadow: { sm: '0 14px 40px rgba(12,62,107,0.6)' },
              },
            }}
          >
            <Icon icon="mdi:chat" width={26} height={26} />
          </IconButton>
        </Badge>
      )}

      <Snackbar
        open={alert.open}
        autoHideDuration={4000}
        onClose={() => setAlert({ ...alert, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert severity={alert.severity} onClose={() => setAlert({ ...alert, open: false })} sx={{ width: '100%' }}>
          {alert.message}
        </Alert>
      </Snackbar>
    </>
  );
}
